import { BillingUiStateKind } from '@this+that/models';
import { getBillingUiState } from '@this+that/utils';

import {
  useActiveTeamId,
  useTeamStore,
} from '../../../store/Team/useTeamStore';

export function useHasActivePaidPlan(): boolean {
  const activeTeamId = useActiveTeamId();
  return useTeamStore((s) =>
    activeTeamId && s.teamsById[activeTeamId]
      ? getBillingUiState(s.teamsById[activeTeamId].team).kind ===
        BillingUiStateKind.ACTIVE
      : false,
  );
}
